import { ActionType } from "../action-types";
import { Action } from "../actions";

export type TwilioAuthState = {
  token: string;
  identity: string;
};

const initialState: TwilioAuthState = {
  token: "",
  identity: "",
};

const twilioReducer = (
  state: TwilioAuthState = initialState,
  action: Action
): TwilioAuthState => {
  switch (action.type) {
    case ActionType.SET_TWILIO_AUTH:
      return {
        token: action.payload.token,
        identity: action.payload.identity,
      };
    default:
      return state;
  }
};

export default twilioReducer;
